<template>
  <div id="chat_page_main" :class="['container', { 'container-dark': theme_dark }]">
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">相册</div>
      <div class="nav-right">
        <img src="../../assets/img/发布.png" class="nav-img none" />
      </div>
    </div>

    <div class="content ub ub-ac3 flexWrap" @click="cancel_gift_show()">
      <li v-for="(item, index) in arr_picture" :key="index"  :style="{ 'background-image': 'url(' + item.url + ')' }" class="image1" @click="show_full(index)">
        <div v-if="locked && index > 1" class="masking ub ub-ac ub-pc">
          <div class="btn ub ub-pc ub-ac" @click="unlock()">
            <span>解锁</span>
          </div>
        </div>
      </li>
      <div class="image1" v-if="arr_picture.length %2 !== 0"></div>
    </div>

    <div class="ub ub-pc ub-ac"  v-if="arr_serve.length > 0 && !locked">
      <div class="btn-more ub ub-ac ub-pc" @click="btn_more()"><span>加载更多</span></div>
    </div>

    <div class="locmore-tips ub ub-ac ub-pc" v-if="locked && arr_serve.length !== 0" @click="unlock()">
        <span>ta还有{{ more_pic }}张照片等你解锁哦~</span>
    </div>

    <give_gifts v-if="gifts_show" :toUid="this.to_uid" :album_gift="album_gift" @gift_hidden="gift_hidden"></give_gifts>
    <full_pic ref="myFullPic"></full_pic>
    <alert ref="myConfirm" @userBehavior="userBehavior"></alert>
    <look_picture ref="showPic"></look_picture>
  </div>
</template>
  
<script>
import Exif from "exif-js";
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import full_pic from "../../components/Full_Pic.vue";
import Give_Gifts from "../Give_Gifts.vue";
import Alert from "../../components/Alert.vue";
import Look_Picture from "../../components/Look_Pictures.vue";
export default {
  components: {
    full_pic: full_pic,
    give_gifts: Give_Gifts,
    alert: Alert,
    look_picture: Look_Picture
  },
  data() {
    return {
      uid: "",
      to_uid: "",
      isColumn: true,
      arr_picture: [],
      arr_serve:[],
      size: 8,
      locked: true,
      gifts_show: false,
      theme_dark: false,
      album_gift: 0,
      more_pic: 0
    };
  },

  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    this.init_page();
  },

  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法
    ...mapActions(["act_reload_userinfo"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },

    init_page() {
      var self = this;
      if (this.$route.params.uid) {
        this.to_uid = this.$route.params.uid;
      } else {
        this.to_uid = this.$store.state.to_uid;
      }

      var uid = this.$store.state.uid;
      this.uid = uid;
      if (this.to_uid == uid) {
        this.locked = false;
      }

      self.get({
        url: "/App/Get_UserRight/?uid_from=" + this.uid + "&uid_to=" + this.to_uid,
        success: function (data) {
        self.album_gift = data.album_gift;
          if (data.state == 1) {
            self.locked = false;
          }
        },
      });

      self.get({
        url: "/App/Get_Album_Other/?uid=" + this.to_uid,
        success: function (data) {
          self.more_pic = data.length - 2;
          for (var i in data) {
            data[i].url = self.$store.state.url + "/photo/" + data[i].url;
          }
          
          self.arr_serve = data;
          self.btn_more();
        },
      });
    },

    //加载更多
    btn_more()
    {
          var self = this;

          var arr_count = self.arr_serve.length;
          if( arr_count >= self.size)
          {
            for(var i=0; i<self.size; i++)
            {
              var item = self.arr_serve.shift();
              self.arr_picture.push(item);
            }
          } else{
            for(var i=0; i<arr_count; i++)
            {
              var item = self.arr_serve.shift();
              self.arr_picture.push(item);
            }
          }
    },

    show_full(index) {
      var arr = this.arr_picture;
      if (this.locked && index > 1) {
        return;
      }
      if (this.locked) {
        arr = this.arr_picture.slice(0, 2)
      }
      this.$refs.showPic.show(arr);
    },

    // 解锁
    unlock() {
      this.$refs.myConfirm.show(
        "解锁ta的相册需要为对方赠送一个礼物表达心意，你送出的礼物会为对方增加魅力值，解锁后24小时内可无限次查看，如需解锁请送上你的心意。",
        {
          type: "confirm",
          confirmText: "解锁",
          titleText: "温馨提示",
          data: "",
        }
      );
    },
    userBehavior(type) {
      setTimeout(() => {
        if (type == "clickConfirm") {
          this.gifts_show = true;
        }
      }, 300);
    },
   
    gift_hidden(gift_item) {
      if (gift_item) {
        this.gifts_show = false;
        this.$toast.center("对方已收到礼物~");
        //已成功发送了礼物，解锁
        setTimeout(() => {
          this.locked = false;
        }, 600);
      }
    },
     cancel_gift_show () {
      this.gifts_show = false;
    },

  },
};
</script>
  
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #efefef;
}
.content {
  .image1 {
    margin: 0.5rem 0;
    width: 45%;
    height: 12rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
  }
  .masking {
    width: 103%;
    height: 103%;
    position: absolute;
    bottom: -2px;
    left: -2px;
    background: linear-gradient(rgba(0, 0, 0, 0.88));
  }
  .btn {
    width: 5rem;
    height: 2rem;
    border-radius: 1rem;
    background: linear-gradient(90deg, #8a61ff 13%, #fe9cc0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #fff;
    }
  }

}

.btn-more {
    margin: 1rem 0;
    padding: 0.5rem 8rem;
    border-radius: 2rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 0.9rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

.locmore-tips {
    margin: 0.5rem 0.6rem 1rem 0.6rem;
    height: 12rem;
    background: linear-gradient(rgba(0, 0, 0, 0.88));
    span {
      font-size: 0.75rem;
      color: #fff;
    }
}

.container-dark {
  background-color: #2f2e33;
}
</style>
  